import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';

interface TransactionDeleteModalProps {
  onDelete: () => void;
  isOpen: boolean;
  onClose: () => void;
  totalTransactions: number;
}

const TransactionDeleteModal = ({
  onDelete,
  isOpen,
  onClose,
  totalTransactions,
}: TransactionDeleteModalProps) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent
        className="min-w-[600px] p-0"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <DialogHeader className="border-b-0 pb-1">
          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-center size-12 bg-bg-error rounded-lg">
              <Icons.Trash01 className="size-5 text-text-error" />
            </div>
            <DialogTitle>Delete {totalTransactions} transactions?</DialogTitle>
          </div>
        </DialogHeader>

        <div className="px-6">
          <p className="txt-small-regular text-text-tertiary">
            You are about to delete {totalTransactions} transactions. This
            action cannot be undone.
          </p>
        </div>

        <DialogFooter className="border-t-0">
          <div className="flex gap-3 items-center justify-end">
            <Button
              variant="secondary"
              onClick={onClose}
              size="sm"
              type="button"
            >
              Cancel
            </Button>
            <Button
              size="sm"
              onClick={onDelete}
              variant="destructive-primary"
              type="button"
            >
              Delete
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TransactionDeleteModal;
